import React, {Component, PropTypes} from 'react';
import CSSModules from 'react-css-modules'
import format from '../../helpers/format'
import {
  Link,
} from '../../components'
import Styles from './PlanScorecardFundIssueAccordionItem.css'

@CSSModules(Styles,{allowMultiple:true})
export default class PlanScorecardFundIssueAccordionItem extends Component {
  static propTypes = {
    fund: PropTypes.object.isRequired,
    el: PropTypes.object.isRequired
  }
  constructor(props){
    super(props)
    this.state = {
      url: this.generateFundDescriptionUrl()
    }
  }

  generateFundDescriptionUrl(){
    let domain = ''
    let path = ''
    switch(this.props.el.id){
      case 'fff':
        domain = 'fossilfreefunds'
        path = 'fossil-fuel-investments'
        break
      case 'dff':
        domain = 'deforestationfreefunds'
        path = 'profile'
        break
      case 'gef':
        domain = 'genderequalityfunds'
        path = 'gender-lens-score'
        break
      case 'gff':
        domain = 'gunfreefunds'
        path = 'gun-investments'
        break
      case 'pff':
        domain = 'prisonfreefunds'
        path = 'prison-industrial-complex-investments'
        break
      case 'wff':
        domain = 'weaponfreefunds'
        path = 'weapon-investments'
        break
      case 'tff':
        domain = 'tobaccofreefunds'
        path = 'tobacco-profile'
        break
    }
    const sName = format.sanitize(this.props.fund.fund_legal_name)
    const sTicker = this.props.fund.ticker || 'N'
    const { fund_id, investment_vehicle_id} = this.props.fund
    return `https://${domain}.org/fund/${sName}/${sTicker}/${path}/${fund_id}/${investment_vehicle_id}`
  }

  //
  render(){
    return (
      <div styleName='esg-btn-wrap'>
        <Link
          to={this.state.url}
          title={this.props.el.name + ' - ' + this.props.fund.fund_legal_name}
        >
          <div styleName='esg-btn'>
            <div styleName='esg-btn-lbl'>
              <b>{this.props.el.name}</b>
              <br/>
              <span>{this.props.el.description}</span>
            </div>
            <div styleName={`esg-btn-grade grade-${this.props.fund[this.props.el.grade]}`}>
              {format.score(this.props.fund[this.props.el.grade])}
            </div>
          </div>
        </Link>
      </div>
    )
  }
}